import Wizard from "./src/Wizard";

export default {
    install(Vue, options) {
        Vue.component("Wizard", Wizard);
    }
};

